import { ColumnDefBase } from '@tanstack/react-table';

import { ColumnTypesInternal } from 'support/types/webediTable';

/**
 * Control columns, not data columns: they size to their content instead of taking a share of the
 * table's column width (see `calculateCellStyle`, which leaves their width unset).
 */
export const isActionColumn = <TData, TValue>(column: ColumnDefBase<TData, TValue>) => {
  return (
    column.meta?.type === ColumnTypesInternal.procuros_select ||
    column.meta?.type === ColumnTypesInternal.procuros_delete ||
    column.meta?.type === ColumnTypesInternal.procuros_collapse
  );
};
